import React from "react";
import './scss/LatestArrival.scss';
import LatestArrivalCarousel from "./Carousel/LatestArrivalCarousel";
import { useTranslation } from "react-i18next";

const LatestArrival = () => {
    let { t } = useTranslation();

    const imgArr = [
        {
            img: "https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/bubu/sliderimg/img1.png",
        },
        {
            img: "https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/bubu/sliderimg/img10.png",
        },
        {
            img: "https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/bubu/sliderimg/img2.png",
        },
        {
            img: "https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/bubu/sliderimg/img3.png",
        },
        {
            img: "https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/bubu/sliderimg/img4.png",
        },
        {
            img: "https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/bubu/sliderimg/img5.png",
        },
        {
            img: "https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/bubu/sliderimg/img6.png",
        },
    ];
    return (
        <div className="mt-5">
            <div
                id={'latestArrivalTitle'}
                className="d-flex mb-5 md:mb-5 justify-center"
            >
                <div className="breadCrumb d-flex w-1/2 justify-around items-center">
                    <hr className="hidden md:block w-16" />
                    <div>
                        <h2>{t("latestArrival")}</h2>
                    </div>
                    <hr className="hidden md:block w-16" />
                </div>
            </div>
            <div className="mt-14 ">
                <LatestArrivalCarousel images={imgArr} />
                <div className="border-b-4 border-dashed border-gray-800"></div>
            </div>
        </div>
    );
};

export default LatestArrival;
